import { defineComponent as _defineComponent } from 'vue'
import { store } from '@/store';
import { computed, ref } from 'vue';
import IconResize from '@/ui/icons/IconResize.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'SizeFlyoverContent',
  setup(__props) {

const product = computed<ProductBaseViewModel<VariantBaseViewObject>>(() => store.getters['catalog/product']);

const zoomModalToggled = ref<boolean>(false);

const sketchWithMeasurementsImages = computed<ImageWithLinkViewObject[]>(() => {
    const imageUrl = product.value.sketchWithMeasurementsImage;
    return [
        {
            imageUrl,
            altText: null,
            link: null,
            title: null
        }
    ];
});

return { __sfc: true,product, zoomModalToggled, sketchWithMeasurementsImages, IconResize }
}

})